module.exports = __webpack_public_path__ + "static/img/A.279c86b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/A.png
// module id = O7fD
// module chunks = 0